import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {TableModule} from "primeng/table";
import {DatePipe} from "@angular/common";
import {MessageService} from "primeng/api";
import {FeedbackService} from "../../services/feedback.service";
import {MarketResearchQuestionDto} from "admin-api-dto";

@Component({
  selector: 'app-market-research-questions-tab',
  standalone: true,
  imports: [TableModule, DatePipe],
  templateUrl: './market-research-questions-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarketResearchQuestionsTabComponent {
  private readonly feedbackService = inject(FeedbackService);
  private readonly messageService = inject(MessageService);

  protected readonly items = signal<MarketResearchQuestionDto[]>([]);
  protected readonly loading = signal(true);

  constructor() {
    this.feedbackService.getMarketResearchQuestions().subscribe({
      next: items => {
        this.items.set(items.filter(item => item.response !== 'skipped'));
        this.loading.set(false);
      },
      error: () => {
        this.loading.set(false);
        this.messageService.add({severity: 'error', summary: 'Failed to load market research questions'});
      }
    });
  }
}
